import type { RegionEncounterTimersSnapshot } from "@ninja/contracts";

export interface RegionEncounterTimerLabels {
  elite: string | null;
  boss: string | null;
}

export function formatCountdown(remainingMs: number): string {
  const totalSeconds = Math.ceil(Math.max(0, remainingMs) / 1_000);
  const seconds = totalSeconds % 60;
  const totalMinutes = Math.floor(totalSeconds / 60);
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);
  const pad = (value: number): string => String(value).padStart(2, "0");
  return hours > 0
    ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    : `${pad(totalMinutes)}:${pad(seconds)}`;
}

export function regionEncounterTimerLabels(
  snapshot: RegionEncounterTimersSnapshot,
  serverNowMs: number,
): RegionEncounterTimerLabels {
  const eliteRemaining =
    snapshot.elite.respawnAtMs === null
      ? 0
      : snapshot.elite.respawnAtMs - serverNowMs;
  const bossRemaining =
    snapshot.boss.cooldownUntilMs === null
      ? 0
      : snapshot.boss.cooldownUntilMs - serverNowMs;

  return {
    elite:
      snapshot.elite.status === "respawning" && eliteRemaining > 0
        ? `ELITE ${formatCountdown(eliteRemaining)}`
        : null,
    boss:
      bossRemaining > 0 ? `BOSS ${formatCountdown(bossRemaining)}` : null,
  };
}
